import { forwardRef } from 'react'
import { IconProps } from '../Types'

interface Props extends IconProps {
  colored?: boolean
}

export const MarkupDecorationsChanges = forwardRef<SVGSVGElement, Props>(
  ({ color = 'currentColor', size = 16, colored = false }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6296 8V7.96029C10.6296 7.6137 10.6964 7.31825 10.8299 7.07393C10.9663 6.82677 11.1523 6.63927 11.3881 6.51143C11.6268 6.38359 11.8967 6.31967 12.1978 6.31967C12.6381 6.31967 12.9819 6.45319 13.229 6.72024C13.4762 6.98444 13.5998 7.3566 13.5998 7.83671V8H10.6296ZM9.35547 9V11.8467H10.6296V9H13.5998V11.8467H14.8739V9H15.75V8H14.8739V7.68331C14.8739 7.13785 14.7802 6.68331 14.5927 6.31967C14.408 5.95319 14.1467 5.67762 13.8086 5.49296C13.4734 5.30831 13.0813 5.21598 12.6325 5.21598C12.1239 5.21598 11.712 5.31967 11.3967 5.52705C11.0813 5.73444 10.8469 6.01427 10.6935 6.36654H10.6126V3.11938H9.35547V8H8.25V9H9.35547Z"
          fill={colored ? '#dd4740' : color} // --negative-50
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.70028 5.95739H8.02983C7.95597 5.48864 7.81392 5.07244 7.60369 4.70881C7.39347 4.34233 7.12784 4.03267 6.80682 3.77983C6.4858 3.52415 6.12358 3.33097 5.72017 3.20028C5.3196 3.06676 4.88778 3 4.42472 3C3.67188 3 3 3.1804 2.40909 3.54119C1.81818 3.89915 1.35227 4.41335 1.01136 5.08381C0.670455 5.75142 0.5 6.55114 0.5 7.48295C0.5 8.41193 0.669034 9.21165 1.0071 9.8821C1.34801 10.5526 1.81392 11.0682 2.40483 11.429C2.99574 11.7869 3.66903 11.9659 4.42472 11.9659C4.90483 11.9659 5.34801 11.8949 5.75426 11.7528C6.16051 11.6108 6.52131 11.4105 6.83665 11.152C7.15483 10.8906 7.41477 10.581 7.61648 10.223C7.82102 9.86222 7.95881 9.46733 8.02983 9.03835L6.70028 9.03409C6.64631 9.3125 6.5483 9.55966 6.40625 9.77557C6.26705 9.98864 6.09659 10.169 5.89489 10.3168C5.69318 10.4645 5.46733 10.5767 5.21733 10.6534C4.97017 10.7273 4.70881 10.7642 4.43324 10.7642C3.93608 10.7642 3.48864 10.6392 3.09091 10.3892C2.69318 10.1392 2.37926 9.76989 2.14915 9.28125C1.92187 8.79261 1.80824 8.19318 1.80824 7.48295C1.80824 6.77841 1.92187 6.18182 2.14915 5.69318C2.37926 5.20455 2.69176 4.83381 3.08665 4.58097C3.48438 4.32813 3.93466 4.2017 4.4375 4.2017C4.71591 4.2017 4.97869 4.24006 5.22585 4.31676C5.47585 4.39347 5.7017 4.5071 5.90341 4.65767C6.10511 4.80824 6.27557 4.99148 6.41477 5.20739C6.55398 5.4233 6.64915 5.6733 6.70028 5.95739ZM0.824218 12.8467H7.82422V13.8467H0.824218V12.8467Z"
          fill={colored ? '#13a745' : color} // --positive-50
        />
      </svg>
    )
  },
)

export default MarkupDecorationsChanges
